// extracted by mini-css-extract-plugin
export default {"container":"cs-z","heading":"ds-z","text":"es-z","info":"fs-z","link":"gs-z","fullMaxWidth":"hs-z"};